import React, { useEffect, useRef, useState } from "react";
import FilterIcon from "../../../../Assets/Images/Svg/FilterIcon.svg";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Tabs,
} from "antd";
import Dragger from "antd/es/upload/Dragger";
import { CloudUploadOutlined } from "@ant-design/icons";
import AuthService from "../../../../Services/AuthService";
import AddReport from "./AddReport";
import PatientService from "../../../../Services/PatientService";
import NoDataFound from "../../../../Assets/Icons/NoDataCard2.svg";
import TabPane from "antd/es/tabs/TabPane";
import LabOrderService from "../../../../Services/LabOrderService";
import ConsultationService from "../../../../Services/ConsultationService";
import dayjs from "dayjs";

const Reports = ({ selectedPatient, permissionData }) => {
  const activePatient = JSON.parse(localStorage.getItem("patient"));
  const patientCode = activePatient?.patientId;
  const [myReport, setMyReport] = useState([]);
  const [labReports, setLabReports] = useState([]);
  const [ecgReports, setEcgReports] = useState([]);
  const [labReportLoad, setLabReportLoad] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [labReportModal, setLabReportModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [viewDoc, setviewDoc] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
  const formRef = useRef();
  const formRef2 = useRef();
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    fetchPatientPermission();
    setIsFiltered(false);
  }, []);

  const fetchPatientPermission = async () => {
    if (permissionData && permissionData.reports === "Y") {
      PatientReport(permissionData.reports === "Y");
      patientLabReports(permissionData.reports === "Y");
      fetchECGReports(permissionData.reports === "Y");
    }
  };

  const fetchECGReports = async (permission) => {
    const patient = JSON.parse(localStorage.getItem("patient"));
    let payload = {
      patientId: patient.patientId,
    };
    try {
      const response = await ConsultationService.fetchECGgraph(payload);
      setEcgReports(Array.isArray(response.data) ? response.data : []);
    } catch (e) {
      setEcgReports([]);
    }
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    fetchPatientPermission();
  };

  const showModal = () => {
    setIsModalOpen(true);
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModal1 = () => {
    setIsModalOpen1(true);
  };

  const handleLabReportModal = () => {
    setLabReportModal(!labReportModal);
  };

  const [btn, setBtn] = useState("1");

  const handleLabReportFilter = async () => {
    const { fromdate, todate } = formRef.current.getFieldsValue();
    const fromDate = dayjs(fromdate).format("MM/DD/YYYY");
    const toDate = dayjs(todate).format("MM/DD/YYYY");
    const payload = {
      patientId: selectedPatient.patientId,
      fromDate,
      toDate,
      status: 1,
    };
    try {
      const response = await LabOrderService.getLabReportsData(payload);
      setLabReports(response.data);
      setLabReportModal(false);
      setIsFiltered(true);
      await fetchFilteredECGReports(fromDate, toDate);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchFilteredECGReports = async (fromDate, toDate) => {
    const patient = JSON.parse(localStorage.getItem("patient"));
    let payload = {
      patientId: patient.patientId,
      fromDate,
      toDate,
    };
    try {
      const response = await ConsultationService.fetchECGgraph(payload);
      setEcgReports(Array.isArray(response.data) ? response.data : []);
    } catch (e) {
      setEcgReports([]);
    }
  };

  const handleClearFilter = () => {
    patientLabReports(permissionData.reports === "Y");
    fetchECGReports(permissionData.reports === "Y");
    setIsFiltered(false);
  };

  const handleOk1 = () => {
    const { fromDate, toDate } = formRef2.current.getFieldsValue();

    if (!fromDate && !toDate) {
      message.error("Select Dates to Filter");
      return;
    }

    const fromDate1 = fromDate ? dayjs(fromDate).format("MM/DD/YYYY") : null;
    const toDate1 = fromDate ? dayjs(toDate).format("MM/DD/YYYY") : null;

    const patient = JSON.parse(localStorage.getItem("patient"));
    const userObj = localStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;

    let payload = {
      userId: userData?.user?.userId,
      patientId: patient.patientId,
      documentType: "MY REPORT",
      status: 1,
    };
    payload.fromDate = fromDate1 ? fromDate1 : null;
    payload.toDate = toDate1 ? toDate1 : null;
    setLoading(true);

    AuthService.getMyReport(payload)
      .then((result) => {
        setMyReport(result.data);
        setBtn("2");
      })
      .catch((error) => {
        console.error("Failed to fetch reports:", error);
        setMyReport([]);
      })
      .finally(() => {
        setLoading(false);
      });

    setIsModalOpen1(false);
  };
  const handleCancel1 = () => {
    setIsModalOpen1(false);
  };

  const handleViewDoc = (report) => {
    setSelectedDoc(report);
    setviewDoc(true);
  };

  const handleViewDoc2 = (report) => {
    setSelectedDoc(null);
    const reportObj = {
      ...report,
      documentName: report.resultDocumentName,
    };
    setSelectedDoc(reportObj);
    setviewDoc(true);
  };

  const handleViewECGDoc = (report) => {
    setSelectedDoc({
      ...report,
      documentName: report.resultDocumentName,
      title: "ECG Report",
    });
    setviewDoc(true);
  };

  const handleDocOk = () => {
    setviewDoc(false);
  };
  const handleDocCancel = () => {
    setviewDoc(false);
  };

  const PatientReport = (permission) => {
    const patient = JSON.parse(localStorage.getItem("patient"));
    const userObj = localStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;

    let payload = {
      userId:
        permission === null || permission === "N" ? userData?.user?.userId : "",
      patientId: patient.patientId,
      documentType: "MY REPORT",
      status: 1,
    };
    setLoading(true);

    AuthService.getMyReport(payload)
      .then((result) => {
        setMyReport(result.data);
      })
      .catch((error) => {
        setMyReport([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const patientLabReports = async (permission) => {
    const patient = JSON.parse(localStorage.getItem("patient"));
    const userObj = localStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;

    setLabReportLoad(true);
    let payload = {
      userId:
        permission === null || permission === "N" ? userData?.user?.userId : "",
      patientId: patientCode,
      status: 1,
    };

    try {
      const response = await LabOrderService.getLabReportsData(payload);
      setLabReports(response.data);
      setLabReportLoad(false);
    } catch (e) {
      setLabReportLoad(false);
    }
  };

  return (
    <>
      <Tabs>
        <TabPane tab="Medical Reports(self)" key={"1"}>
          <div className="p-4 border rounded shadow-md">
            <div className="flex justify-between ">
              <div></div>
              <div className="flex  gap-3">
                <Button
                  onClick={showModal}
                  className="h-9 px-2 flex justify-center text-white items-center gap-2 custom_filter"
                >
                  + New
                </Button>
                {btn === "1" ? (
                  <Button
                    className="h-9 px-2 flex justify-center text-white items-center gap-2 custom_filter"
                    onClick={showModal1}
                  >
                    <span>
                      <img
                        src={FilterIcon}
                        alt="Icon"
                        className="custom_filter hover:text-brand-primaryColor"
                      />
                    </span>
                    <span className=""> Filter</span>
                  </Button>
                ) : (
                  <Button
                    className="h-9 px-2 flex justify-center text-white items-center gap-2 custom_filter"
                    onClick={() => {
                      setBtn("1");
                      PatientReport("Z");
                    }}
                  >
                    <span>
                      <img
                        src={FilterIcon}
                        alt="Icon"
                        className="custom_filter hover:text-brand-primaryColor"
                      />
                    </span>
                    <span className=""> Clear</span>
                  </Button>
                )}
              </div>
            </div>
            <div className="my-2 flex">
              {loading ? (
                <div className="w-full flex h-screen justify-center items-center">
                  <div className="spinner"></div>
                </div>
              ) : myReport && myReport.length > 0 ? (
                <div className="w-full grid grid-cols-2 gap-2">
                  {myReport.map((report, i) => (
                    <div key={i} className="w-full">
                      <div className="border shadow-lg p-3 rounded-lg my-2 bg-white">
                        <div className="flex justify-between">
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Date</label>
                            <p className="font-normal">{report.documentDate}</p>
                          </div>
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Title</label>
                            <p className="font-normal">{report.title}</p>
                          </div>
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Document Type</label>
                            <p className="font-normal">{report.documentType}</p>
                          </div>
                        </div>
                        <div
                          className="underline cursor-pointer text-brand-primaryColor my-1 font-medium"
                          onClick={() => handleViewDoc(report)}
                        >
                          View Document
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="w-full flex flex-col justify-center items-center">
                  <img src={NoDataFound} alt="No Data" className="w-96 h-96" />
                  <p className="text-center">No Reports Found</p>
                </div>
              )}
            </div>
          </div>
        </TabPane>
        <TabPane tab="Lab Reports" key={"2"}>
          <div className="p-4 border rounded shadow-md ">
            <div className="flex justify-between ">
              <div></div>
              <div className="flex  gap-3">
                <Button
                  className="h-9 px-2 flex justify-center text-white items-center gap-2 custom_filter"
                  onClick={handleLabReportModal}
                >
                  <span>
                    <img
                      src={FilterIcon}
                      alt="Icon"
                      className="custom_filter hover:text-brand-primaryColor"
                    />
                  </span>
                  <span className=""> Filter</span>
                </Button>
              </div>
            </div>
            <div className="flex justify-end">
              {isFiltered && (
                <p
                  className="py-2 px-2 flex items-center gap-2 text-brand-primaryColor cursor-pointer"
                  onClick={handleClearFilter}
                >
                  Clear All
                </p>
              )}
            </div>
            <div className="my-6 flex">
              {labReportLoad || loading ? (
                <div className="w-full flex h-screen justify-center items-center">
                  <div className="spinner"></div>
                </div>
              ) : labReports && labReports.length > 0 ? (
                <div className="w-full grid grid-cols-2 gap-2">
                  {labReports.map((report, i) => (
                    <div key={i} className="w-full ">
                      <div className="border shadow-lg p-3 rounded-lg my-2 bg-white relative">
                        <span
                          className={`absolute top-0 right-0 rounded-bl-lg rounded-tr-lg px-2 py-1 text-xs font-semibold text-white ${
                            loggedUser.user.account_Id === report.vendorId
                              ? "bg-blue-500"
                              : "bg-blue-500"
                          }`}
                        >
                          {loggedUser.user.account_Id === report.vendorId
                            ? "Internal"
                            : "External"}
                        </span>
                        <div className="flex justify-between my-4">
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Date</label>
                            <p className="font-normal">
                              {report.uploadedDateTime?.split(" ")[0]}
                            </p>
                          </div>
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Title</label>
                            <p className="font-normal">{report.labTestName}</p>
                          </div>
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Document Type</label>
                            <p className="font-normal">
                              {report.resultDocumentType}
                            </p>
                          </div>
                        </div>
                        <div
                          className="underline cursor-pointer text-brand-primaryColor my-1 font-medium"
                          onClick={() => handleViewDoc2(report)}
                        >
                          View Document
                        </div>
                      </div>
                    </div>
                  ))}
                  {/* ECG REPORTS LISTING */}
                  {ecgReports.map((report, i) => (
                    <div key={`ecg-${report.id || i}`} className="w-full">
                      <div className="border shadow-lg p-3 rounded-lg my-2 bg-white">
                        <div className="flex justify-between">
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Date</label>
                            <p className="font-normal">
                              {dayjs(report.createdDate).format("MM/DD/YYYY")}
                            </p>
                          </div>
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Title</label>
                            <p className="font-normal">ECG Report</p>
                          </div>
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Document Type</label>
                            <p className="font-normal">ECG</p>
                          </div>
                        </div>
                        <div
                          className="underline cursor-pointer text-brand-primaryColor my-1 font-medium"
                          onClick={() => handleViewECGDoc(report)}
                        >
                          View Document
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="w-full flex flex-col justify-center items-center">
                  <img src={NoDataFound} alt="No Data" className="w-96 h-96" />
                  <p className="text-center">No Reports Found</p>
                </div>
              )}
            </div>
          </div>
        </TabPane>
      </Tabs>

      <Modal
        title={<span className="font-bold">Add Report</span>}
        visible={isModalVisible}
        onOk={() => handleCloseModal()}
        centered={true}
        footer={null}
        onCancel={() => handleCloseModal()}
        okText="Submit"
        cancelText="Cancel"
        width={600}
        maskClosable={false}
      >
        <AddReport onClose={handleCloseModal} />
      </Modal>
      <Modal
        title={<span className="font-bold">Filter Reports</span>}
        className="commonModal"
        footer={false}
        open={isModalOpen1}
        onOk={showModal1}
        onCancel={handleCancel1}
      >
        <Form
          layout="vertical"
          autoComplete="off"
          className=" grid grid-cols-2 gap-5"
          ref={formRef2}
        >
          <Form.Item
            className="mb-0"
            label={<span className="font-medium">From Date</span>}
            name="fromDate"
          >
            <DatePicker
              placeholder="fromDate "
              className="w-full"
              format="MM/DD/YYYY"
            />
          </Form.Item>
          <Form.Item
            className="mb-0"
            label={<span className="font-medium">To Date</span>}
            name="toDate"
          >
            <DatePicker
              placeholder="toDate"
              className="w-full"
              format="MM/DD/YYYY"
            />
          </Form.Item>
        </Form>
        <div className=" flex justify-end gap-3 mt-3 ">
          <button
            onClick={handleCancel1}
            className="bg-White border-primaryColor border rounded-md text-base text-white p-2"
          >
            Cancel
          </button>
          <button
            onClick={handleOk1}
            className="bg-brand-primaryColor p-2 text-base rounded-md text-white"
          >
            Submit
          </button>
        </div>
      </Modal>

      <Modal
        title={<span className="font-bold">Filter Reports</span>}
        className="commonModal"
        footer={false}
        open={labReportModal}
        onOk={handleLabReportModal}
        onCancel={handleLabReportModal}
      >
        <Form
          layout="vertical"
          autoComplete="off"
          className=" grid grid-cols-2 gap-5"
          ref={formRef}
        >
          <Form.Item
            className="mb-0"
            label={<span className="font-medium">From Date</span>}
            name="fromdate"
          >
            <DatePicker
              placeholder="fromDate "
              className="w-full"
              format="MM/DD/YYYY"
            />
          </Form.Item>
          <Form.Item
            className="mb-0"
            label={<span className="font-medium">To Date</span>}
            name="todate"
          >
            <DatePicker
              placeholder="toDate"
              className="w-full"
              format="MM/DD/YYYY"
            />
          </Form.Item>
        </Form>
        <div className=" flex justify-end gap-3 mt-3 ">
          <button
            onClick={handleLabReportModal}
            className="bg-White border-primaryColor border rounded-md text-base text-white p-2"
          >
            Cancel
          </button>
          <button
            onClick={handleLabReportFilter}
            className="bg-brand-primaryColor p-2 text-base rounded-md text-white"
          >
            Submit
          </button>
        </div>
      </Modal>

      <Modal
        title={selectedDoc?.title}
        open={viewDoc}
        footer={[]}
        onOk={handleDocOk}
        onCancel={handleDocCancel}
        width={selectedDoc?.title === "ECG Report" ? 1200 : undefined}
      >
        {selectedDoc?.title === "ECG Report" ? (
          <iframe
            src={selectedDoc?.documentName}
            title="ECG Report"
            style={{ width: "100%", height: "500px" }}
          />
        ) : selectedDoc?.documentName &&
          (selectedDoc?.documentName.endsWith(".jpg") ||
            selectedDoc?.documentName.endsWith(".jpeg") ||
            selectedDoc?.documentName.endsWith(".png")) ? (
          <div className="flex justify-center items-center h-[inherit] w-[inherit]">
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}${selectedDoc?.documentName}`}
              alt="report"
            />
          </div>
        ) : (
          <iframe
            src={`${process.env.REACT_APP_IMAGE_URL}${selectedDoc?.documentName}`}
            title="report"
            style={{ width: "100%", height: "500px" }}
          />
        )}
      </Modal>
    </>
  );
};

export default Reports;
